import React, {useState} from 'react'
import useDidMountEffect from "../../../../../../hooks/useDidMountEffect/useDidMountEffect";
import {
    getPlantillaContentByIdAPI,
    validarRegistrarFlujoDocumentoPaso2API
} from "../../../../../../consumers/backendApisUrls";
import InputSelect from "../../../../../../components/modalComponents/InputSelect";
import {Div} from "../../../../../registroMaternidad/modales/components/Components";
import EditorFlujoDocumentoConExtradatas from "../components/EditorFlujoDocumentoConExtradatas";
import {FlujoDocumentoRequiereExtradata, IdPlantillaDocumentoGenerico} from "../../../../constantes/constantes";
import {useManageGetRequest} from "../../../../../../hooks/useManageGetRequest/useManageGetRequest";
import {isNullOrUndefinded} from "../../../../../../helper/utils";
import EditorFlujoDocumento from "../components/EditorFlujoDocumento";
import {useSubmitForm} from "../../../../../../hooks/useSubmitForm/useSubmitForm";
import InputUploadFile from "../../../../../../components/modalComponents/InputUploadFile";
import {EXTENSION_PDF} from "../../../../../../constants/hardCodedConstants";
import {AlertErrorMaxFileSizeMessageGeneric} from "../../../../../../components/alerts/AlertErrorMaxFileSizeMessage";

const Paso2 = ({
                   sendCurrentStep,
                   setSendCurrentStep,
                   componentStep,
                   KEYS,
                   selectProps,
                   SECTION_NAME,
                   formValues,
                   setFormValues,
                   disableInputs
               }) => {
    const [isLoadingEditor, setIsLoadingEditor] = useState(true);
    const [executeManageGet] = useManageGetRequest();
    const [submitForm] = useSubmitForm();
    const [isSubmitting, setIsSubmitting] = useState(false);

    useDidMountEffect(() => {
        if (sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent) {
            handleSubmit();
        }
    }, [sendCurrentStep])

    useDidMountEffect(() => {
        getTemplateContent();
    }, [formValues[KEYS.IdPlantillaDistribucion]])

    useDidMountEffect(() => {
        if (formValues[KEYS.IdRequiereExtradataDistribucion] === FlujoDocumentoRequiereExtradata.si.Id && !isNullOrUndefinded(formValues[KEYS.CantidadExtraDatas]))
            renderEditor()
        if (formValues[KEYS.IdRequiereExtradataDistribucion] === FlujoDocumentoRequiereExtradata.no.Id)
            renderEditor()
    }, [formValues[KEYS.IdRequiereExtradataDistribucion], formValues[KEYS.CantidadExtraDatas]])

    useDidMountEffect(() => {
        if (formValues[KEYS.IdRequiereExtradataDistribucion] === FlujoDocumentoRequiereExtradata.no.Id) {
            setFormValues(lastData => ({...lastData, [KEYS.CantidadExtraDatas]: null}))
        }
    }, [formValues[KEYS.IdRequiereExtradataDistribucion]])


    useDidMountEffect(() => {
        if (isNullOrUndefinded(formValues[KEYS.IdPlantillaDistribucion]))
            return

        if (formValues[KEYS.IdPlantillaDistribucion] === IdPlantillaDocumentoGenerico) {
            setFormValues(lastData => (
                {
                    ...lastData, [KEYS.RenderEditorDocumento]: null,
                    [KEYS.DocumentoContent]: null,
                    [KEYS.CantidadExtraDatas]: null,
                    [KEYS.IdRequiereExtradataDistribucion]: null,
                }))
        } else {
            setFormValues(lastData => (
                {
                    ...lastData, [KEYS.DocumentoGenerico]: null,
                }))
        }

    }, [formValues[KEYS.IdPlantillaDistribucion]])

    async function getTemplateContent() {
        try {
            const api = getPlantillaContentByIdAPI(formValues[KEYS.IdPlantillaDistribucion]);
            await executeManageGet(api, (res) => successCallbackTemplateContent(res), false);
        } catch (error) {
            console.error(error)
        }
    }

    const successCallbackTemplateContent = (res) => {
        setFormValues(lastData => ({...lastData, [KEYS.DocumentoContent]: res?.data}))
    }

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        //setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
        //return

        let payload = getPayload();

        const api = validarRegistrarFlujoDocumentoPaso2API();

        try {
            await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successSubmitValidarCallback, false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const getPayload = () => {
        return {
            ...formValues,
        }
    }

    const successSubmitValidarCallback = async (responseData) => {
        setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
    }

    const handleChangeEditor = (res) => {
        const data = res;
        setFormValues(lastData => ({...lastData, [KEYS.DocumentoContent]: data}))
    }

    const renderEditor = (e) => {
        if (e)
            e.preventDefault()

        if (isNullOrUndefinded(formValues[KEYS.RenderEditorDocumento])) {
            setFormValues(lastData => ({...lastData, [KEYS.RenderEditorDocumento]: true}))
        } else {
            setFormValues(lastData => ({
                ...lastData,
                [KEYS.RenderEditorDocumento]: !formValues[KEYS.RenderEditorDocumento]
            }))
        }
    }

    return (
        <div className="displayFlexWrap">
            <Div col={6}>
                <InputSelect
                    label="Plantilla"
                    {...selectProps(KEYS.IdPlantillaDistribucion)}
                    sectionName={SECTION_NAME}
                    isDisabled={disableInputs}
                    isRequired={true}
                    placeholder={"Seleccionar Plantilla"}
                    direction="column"
                />
            </Div>

            {formValues[KEYS.IdPlantillaDistribucion] === IdPlantillaDocumentoGenerico &&
                <Div col={12}>
                    <InputUploadFile
                        toolTipText="Adjuntar un solo documento en formato pdf, si posees más de un documento, debes escanear todo como un solo archivo (no mayor de 2MB)"
                        label="Documento Genérico"
                        direction="column"
                        name={KEYS.DocumentoGenerico}
                        uploadFile={formValues[KEYS.DocumentoGenerico]}
                        setUploadFile={(res) =>
                            setFormValues({...formValues, [KEYS.DocumentoGenerico]: res})
                        }
                        sectionName={SECTION_NAME}
                        validExtensions={EXTENSION_PDF}
                        isRequired={true}
                        maxFileSize={2097152} //2MB
                        ToastArchivoNoValido={() => AlertErrorMaxFileSizeMessageGeneric('pdf', '2MB')}
                        isDisabled={disableInputs}
                    />
                </Div>
            }

            {!isNullOrUndefinded(formValues[KEYS.IdPlantillaDistribucion]) && formValues[KEYS.IdPlantillaDistribucion] !== IdPlantillaDocumentoGenerico &&
                <Div col={3}>
                    <InputSelect
                        label="Requiere Extradatas"
                        {...selectProps(KEYS.IdRequiereExtradataDistribucion)}
                        sectionName={SECTION_NAME}
                        isRequired={true}
                        placeholder={"Seleccionar"}
                        direction="column"
                        isDisabled={disableInputs}
                    />
                </Div>
            }

            {formValues[KEYS.IdRequiereExtradataDistribucion] === FlujoDocumentoRequiereExtradata.si.Id &&
                <Div col={3}>
                    <InputSelect
                        label="Cantidad"
                        {...selectProps(KEYS.CantidadExtraDatas)}
                        sectionName={SECTION_NAME}
                        isRequired={true}
                        placeholder={"Seleccionar Cantidad"}
                        direction="column"
                        isDisabled={disableInputs}
                    />
                </Div>
            }

            {formValues[KEYS.IdPlantillaDistribucion] !== IdPlantillaDocumentoGenerico &&
                <Div col={12}>
                    <div style={{minHeight: "50px"}}>
                        {formValues[KEYS.IdRequiereExtradataDistribucion] === FlujoDocumentoRequiereExtradata.si.Id && !isNullOrUndefinded(formValues[KEYS.CantidadExtraDatas]) &&
                            <div style={{backgroundColor: 'white'}}>
                                <EditorFlujoDocumentoConExtradatas
                                    key={formValues[KEYS.RenderEditorDocumento]}
                                    value={formValues[KEYS.DocumentoContent] ?? ""}
                                    handleChange={handleChangeEditor}
                                    idTemplateType={2}
                                    loading={isLoadingEditor}
                                    setLoading={setIsLoadingEditor}
                                    cantidadExtraDatas={formValues[KEYS.CantidadExtraDatas]}
                                    readOnly={disableInputs}
                                />
                                <p className="ficha-form-input-validation-message"
                                   id={`ficha-edit-${SECTION_NAME}-${KEYS.Template}-validation-message`}></p>
                            </div>
                        }

                        {formValues[KEYS.IdRequiereExtradataDistribucion] === FlujoDocumentoRequiereExtradata.no.Id &&
                            <div style={{backgroundColor: 'white'}}>
                                <EditorFlujoDocumento
                                    key={formValues[KEYS.RenderEditorDocumento]}
                                    value={formValues[KEYS.DocumentoContent] ?? ""}
                                    handleChange={handleChangeEditor}
                                    idTemplateType={2}
                                    loading={isLoadingEditor}
                                    setLoading={setIsLoadingEditor}
                                    readOnly={disableInputs}
                                />
                                <p className="ficha-form-input-validation-message"
                                   id={`ficha-edit-${SECTION_NAME}-${KEYS.Template}-validation-message`}></p>
                            </div>
                        }
                    </div>
                </Div>
            }


        </div>
    )
}

export default Paso2;